import CloseSvg from '../../../assets/close.svg?react';
import { IconProps } from '../../types/IconProps';

export function Close({ size = 20, ...props }: IconProps) {
  return <CloseSvg data-testid="close-icon" width={size} height={size} {...props} />;
}

export default Close;
